export default __webpack_public_path__ + "static/media/pc4.b4b606be.jpg";